import { zodResolver } from "@hookform/resolvers/zod";
import { forwardRef } from "react";

import { defaultPersonalFormValues } from "@/D2C/features/car-quote/redux/car-quote/carQuoteSlice";
import type { CarPersonalDetailsAutofillValues } from "@/D2C/features/car-quote/utils/carPersonalDetailsOcr";
import { PersonalDetailsFormStep } from "@/shared/stepper/PersonalDetailsFormStep";
import type { StepFormComponentProps, StepFormHandle } from "@/shared/stepper/types";
import { createPersonalDetailsSchema } from "@/shared/validation/carQuoteSchemas";
import { CarPersonalFormValues } from "../../redux/type";

export const PersonalDetailsStep = forwardRef<
  StepFormHandle<CarPersonalFormValues>,
  StepFormComponentProps<
    CarPersonalFormValues,
    {
      autofillValues?: CarPersonalDetailsAutofillValues;
      autofillVersion?: number;
      layoutClassName?: string;
      showAdditionalFields?: boolean;
      onDemoDataClick?: () => void;
      showVehicleRegistrationNumberField?: boolean;
    }
  >
>(function PersonalDetailsStep(
  {
    defaultValues,
    autofillValues,
    autofillVersion,
    layoutClassName,
    showAdditionalFields,
    onDemoDataClick,
    showVehicleRegistrationNumberField,
  },
  ref
) {
  return (
    <PersonalDetailsFormStep
      ref={ref}
      defaultValues={defaultValues as any}
      resolver={
        zodResolver(
          createPersonalDetailsSchema({
            requireVehicleRegistrationNumber: false,
          })
        ) as any
      }
      fallbackValues={defaultPersonalFormValues as any}
      autofillValues={autofillValues as CarPersonalDetailsAutofillValues}
      autofillVersion={autofillVersion}
      layoutClassName={layoutClassName}
      showAdditionalFields={showAdditionalFields}
      onDemoDataClick={onDemoDataClick}
      showVehicleRegistrationNumberField={showVehicleRegistrationNumberField}
    />
  );
});
